import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Helmet } from 'react-helmet';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

// import Header from '../../static/img/about_belts_page/belt_page_header.png';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    paddingBottom: theme.spacing(10),
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
    textTransform: 'uppercase',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  question: {
    fontWeight: 'bold',
  },
  accordion: {
    marginBottom: theme.spacing(),
  },
  expandMoreIcon: {
    color: theme.palette.blue,
  },
});

class FAQPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(panel, isExpanded) {
    this.setState({
      expanded: isExpanded ? panel : false,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      expanded,
    } = this.state;

    return (
      <div className={classes.page}>

        <Helmet>
          <title>Nia FAQ&apos;s | Dance Fitness Classes for Mind-Body Wellness</title>
          <meta name="description" content="Nia's most frequently asked questions regarding our low impact barefoot dance workouts, dance fitness classes and somatic body life trainings." />
          <meta name="keywords" content="low, impact, dance, workout, dance, fitness, classes" />
        </Helmet>

        <div className={classes.appBarSpacer} />
        <NavBar />
        <main className={classes.container}>
          <Typography variant="h2" className={classes.header}>Frequently Asked Questions</Typography>
          <div className={classes.content}>

            <Accordion className={classes.accordion} expanded={expanded === 'panel1'} onChange={(event, isExpanded) => this.handleChange('panel1', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What is Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nia is a class, practice and lifestyle that blends movement, mindfulness, connection and joy to provide a whole-body / whole-being experience that activates, transforms and liberates body, mind and spirit. Integrating ancient wisdom and modern science with elements of dance, martial arts and healing arts, Nia offers physical, mental and emotional conditioning, healing and transformation that is accessible and attainable for every body.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel2'} onChange={(event, isExpanded) => this.handleChange('panel2', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  Who can do Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nia is for every body.  Any body of any age, fitness level, size, shape and ability can successfully practice Nia. Nia practitioners come from all walks of life but are united in their desire to feel better, move better and live better.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel3'} onChange={(event, isExpanded) => this.handleChange('panel3', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                 What can I expect in a Nia class?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Every Nia class incorporates elements from dance, martial arts and healing arts to provide an accessible, whole-body workout using 52 simple moves and a balance of form/technique and freeform movement. Most Nia classes are 20-60 minutes and will guide you through the 7-cycles of a Nia class.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel4'} onChange={(event, isExpanded) => this.handleChange('panel4', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What are the 7-Cycles of a Nia Class?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <ul>
                  <li>
                    <Typography>
                      <strong>Cycle 1: Set the Focus + Intent </strong>
                      - The focus tells us where we put our attention, the intent tells us why.  Setting the Focus + Intent integrates your body and mind to create a mindful movement experience rather than simply a “workout.”
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 2: Step-In </strong>
                      - We step-in to class, symbolically stepping over a threshold to remove distractions and become fully present for the duration of the class experience.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 3: Warm-Up </strong>
                      - We’ll warm up slowly, moving the body’s 13 major joints to stimulate circulation, mindfully increase the heart rate and increase oxygenation throughout the body.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 4: Get Moving </strong>
                      - We’ll spend the majority of a Nia class in the Get Moving cycle. Guided by an inspiring soundtrack, you will stimulate cardiovascular conditioning, release endorphins and have a whole lot of fun. You are always invited to move in your body’s way and increase or decrease the intensity as desired.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 5: Cool Down </strong>
                      - Just like we warmed up slowly, we’ll cool down slowly and intentionally, bringing down the heart rate and prepare your body to move to the earth.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 6: FloorPlay </strong>
                      - In the FloorPlay cycle, we use gravity, time, space and the floor to consciously condition and self-heal the body - building strength and increasing flexibility and mobility.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Cycle 7: Step-Out </strong>
                      - Just as we stepped in, at the close of the Nia class, we’ll intentionally step-out, and step-into the rest of our life, leaving behind anything that no longer serves.
                    </Typography>
                  </li>
                </ul>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel5'} onChange={(event, isExpanded) => this.handleChange('panel5', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  I have two left feet… can I still do Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  This is the most common question we receive. Other variations include “I’m not a dancer…”, “I’m not coordinated…” or “I have no rhythm… is Nia for me?”  The answer to all of these questions is 100% YES.  While Nia does incorporate elements of dance - it’s not like any dance you’ve experienced before.  It’s not about getting the steps “right” or moving just like your teacher or other students.  It’s about moving in YOUR body’s way - guided and encouraged by a teacher who honors that each and every body is unique.  You’ll learn simple steps that are repeated to create easy-to-follow patterns to activate and engage your brain while also conditioning your body.  While it’s normal to feel a little awkward whenever you’re beginning something new, most students report feeling more confident and comfortable within a few classes.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel6'} onChange={(event, isExpanded) => this.handleChange('panel6', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What are the benefits of Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nia offers a longlist of benefits including (but not limited to):
                </Typography>
                <ul>
                  <li><Typography>Increased confidence, pleasure and joy of living in your body (Many practitioners share that they finally feel good in their own skin)</Typography></li>
                  <li><Typography>Increased balance, agility, grace and flexibility</Typography></li>
                  <li><Typography>Enhanced endurance, stamina and lung capacity</Typography></li>
                  <li><Typography>Enhanced strength, muscle tone and definition</Typography></li>
                  <li><Typography>Reduced stress and an enhanced sense of calm and relaxation</Typography></li>
                  <li><Typography>Improved concentration and cognitive function</Typography></li>
                  <li><Typography>Heightened sexual function and pleasure</Typography></li>
                  <li><Typography>Enhanced emotional resilience and reduced depression and anxiety</Typography></li>
                  <li><Typography>Improved sleep</Typography></li>
                  <li><Typography>Strengthened immunity</Typography></li>
                  <li><Typography>Improved sense of overall well-being: Body, Mind, Emotions and Spirit</Typography></li>
                  <li><Typography>And so much more!</Typography></li>
                </ul>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel7'} onChange={(event, isExpanded) => this.handleChange('panel7', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What do I wear to a Nia class?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Wear anything that you feel good in and allows you to move comfortably.  Consider layers to add or subtract as you warm up and cool down.  Most practitioners practice Nia in bare feet. If you have concerns about being barefoot, consider a soft-soled shoe or ask your Nia teacher what they recommend.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel8'} onChange={(event, isExpanded) => this.handleChange('panel8', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  Can I do Nia if I’m out of shape?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  YES!  Nia can be adapted for any level of fitness, age or ability.  If you are just beginning your movement journey, consider starting with a Nia Moving to Heal class (seated options are available.)  Classic Nia and Move IT classes offer more vigor and conditioning.  In all Nia classes, you’re invited and encouraged to listen to your body and do just what feels right to you.  With practice, you’ll learn to move in your body’s own way, time and speed. With consistent practice, your endurance, capacity and skill will improve!
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel9'} onChange={(event, isExpanded) => this.handleChange('panel9', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  I’m in great shape. Will Nia actually give me a good workout?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  ABSOLUTELY!  Nia can be personalized for your level of fitness and can be made as intense (or gentle) as you desire.  Nia is practiced by Olympic Athletes and beginners alike.  Nia offers an entire suite of tools and techniques to personalize the intensity of your experience and get just what you and your body need!
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel10'} onChange={(event, isExpanded) => this.handleChange('panel10', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  I have an injury (...), illness (...) or physical disability. Can I do Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Before beginning any movement program, you should always consult with your doctor. However, Nia is based on the design of the body and can be modified to accommodate physical disabilities and support self-healing for most injuries and illnesses. If you are living with acute or chronic injury, illness or physical disability, a Nia Moving to Heal class may be a good place to start. Alternatively, you may choose to schedule a private session with one of our licensed Nia teachers or trainers.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel12'} onChange={(event, isExpanded) => this.handleChange('panel12', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What is the science behind Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nia is based on The Body’s Way, which means using the body’s natural design to improve function. The biochemistry, joints and muscles are triggered using 52 body-centered moves, imagination, music, emotion and vocal sound. Movements work with and against gravity and include: abduction, adduction; flexion, extension; eversion, inversion; dorsal flexion, plantar flexion, pronation and supination; horizontal flexion, extension; rotation inward, outward, upward and downward, elevation, depression, and circumduction. Nia addresses the body’s five main sensations: flexibility, strength, mobility, agility and stability and focuses on conditioning the body and the nervous system.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel13'} onChange={(event, isExpanded) => this.handleChange('panel13', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  What does it mean that Nia is a “Practice” and “Lifestyle”?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Much like the ancient practice of Yoga, Nia can be experienced as a “Class” a “Practice” or a “Lifestyle.”  Most people begin by taking the Nia “Class” and experience the benefits, joy and freedom of Nia on the “dance floor.” A Nia “Practice” develops as students attend classes as a consistent part of their life and routine. Finally, many students discover they want to take the benefits they’re experiencing in their Nia classes and practice off the dance floor and into LIFE.  Enrolling in the Nia White Belt begins the Nia Body + Life Education path and provides deep somatic education with tools, techniques and practices to integrate Nia into every aspect of life.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel14'} onChange={(event, isExpanded) => this.handleChange('panel14', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  Who created Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nia was created by founders Debbie and Carlos Rosas in 1983. In an age of “no pain, no gain” and “feel-the-burn” high-impact aerobic fitness, Debbie and Carlos believed there had to be a better way. Leaving successful careers in the booming high-impact aerobics industry behind, they embarked on a quest to find an alternative way to move, condition and heal the body that would integrate the body, mind and spirit and, ultimately, revolutionize the face of fitness as we know it.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel15'} onChange={(event, isExpanded) => this.handleChange('panel15', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  Where can I find Nia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Find hundreds of on-demand Nia classes online atniaondemand.com or discover a live Nia class online or in-person with a licensed Nia teacher.  Nia is taught in nearly every state in the US, as well as in 43 other countries around the world. Nia is offered in a variety of settings – from gyms and fitness centers to the finest spas and resorts. You’ll find Nia in: Fitness and Health Clubs, Yoga Studios, YMCA’s, Pilates Studios, Healing and Wellness Centers, Senior Centers, Retreats, Summer Camps, Personal Growth and Transformation Seminars and Conferences, HMO Programs, Corporate Wellness Programs, Teen and Inner City Youth Groups, University PE, Theater, Pre-med Departments, Dance & Martial Arts Schools, Spas, Hospitals, Prisons, and Drug/Alcohol & Cardiac Rehabilitation Centers – to name a few!
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel16'} onChange={(event, isExpanded) => this.handleChange('panel16', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  How do you pronounce &quot;Nia&quot;?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  Nee-uhh
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.accordion} expanded={expanded === 'panel17'} onChange={(event, isExpanded) => this.handleChange('panel17', isExpanded)}>
              <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}>
                <Typography className={classes.question}>
                  When is the best time to begin a Nia practice?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Typography>
                  The time to start moving and feeling better in your body is NOW!  Why wait on your journey to a happier, healthier body and life?  Find a class or start your free trial of Nia On Demand now.
                </Typography>
              </AccordionDetails>
            </Accordion>

          </div>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

FAQPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FAQPage);
